export default "__VITE_ASSET__119665c7__"